import React from 'react'

// Types
import { AuthState } from '../types'

export const initialState: AuthState = {
  user: null,
  fetching: true,
  actions: {
    authenticate: () => {},
    login: () => {},
    logout: () => {},
    signup: () => {},
    setFetching: () => {},
  },
}

const NavigationContext = React.createContext(initialState)

export default NavigationContext
